// Module
var code = "<template><require from=\"../../../components/custom-button/custom-button\"></require><div class=\"row end-xs\"><custom-button class=\"padding-5 primary\" click.trigger=\"changeStatus()\">Change Status</custom-button></div></template>";
// Exports
module.exports = code;